import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch,  Link} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'
import StudentLogin from './StudentLogin';
import StaffLogin from './StaffLogin';
import AdminLogin from './AdminLogin';
import Student from './Student';
import Staff from './Staff';
import Admin from './Admin';
import PrivacyPolicy from './PrivacyPolicy';


class Approot extends Component {

   constructor(props) {
    super(props);

    this.updateStudentDetails = this.updateStudentDetails.bind(this);
    this.updateStaffDetails = this.updateStaffDetails.bind(this);
    this.updateAdminDetails = this.updateAdminDetails.bind(this);
    this.renderInThousands = this.renderInThousands.bind(this);

     this.state={
       user_details:{},
       user_token:"",
       student_details:{},
       admin_details:{},
       staff_details:{},
       loginStatus: false,
       //production parameters
      base_url:"http://41.139.253.126:3080",
      //base_url:"https://1654b26e.ngrok.io",
      //base_url:"http://localhost:3080",
      portal_base_url:"http://ettiportal.com:5000",

       //development parameters
       //base_url:"http://localhost:3080",
       //portal_base_url:"http://localhost:3000"

    }
  }



  updateStudentDetails(studentData, loginStatus) {

    console.log("updating student data");
    this.setState({student_details:studentData, loginStatus: loginStatus});
  }

  updateStaffDetails(staffData, loginStatus) {

    console.log("updating staff data");
    this.setState({staff_details:staffData, loginStatus: loginStatus});
  }

  updateAdminDetails(adminData, loginStatus) {

    console.log("updating admin data");
    this.setState({admin_details:adminData, loginStatus: loginStatus});
  }

  renderInThousands(num)
  {
    let num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }


  render() {

    const _this = this;


    return (
      <BrowserRouter>
          <Switch>
              <Route  exact path="/"
                      render={(props) => <StudentLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus = {this.state.loginStatus}
                                                                updateStudentDetails={_this.updateStudentDetails.bind(_this)}/>}
              />

              <Route  path="/student"
                      render={(props) => <StudentLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus= {this.state.loginStatus}
                                                                updateStudentDetails={_this.updateStudentDetails.bind(_this)} />}
              />
              <Route
                    path="/student_ui"
                    render={(props) => <Student {...props}
                                                          base_url={_this.state.base_url}
                                                          renderInThousands = {_this.renderInThousands.bind(_this)}
                                                          portal_base_url={_this.state.portal_base_url}
                                                          loginStatus= {this.state.loginStatus}
                                                          student_details = {_this.state.student_details}
                                                          updateStudentDetails={_this.updateStudentDetails.bind(_this)}/>}
              />

              <Route  path="/admin"
                      render={(props) => <AdminLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus= {this.state.loginStatus}
                                                                updateAdminDetails={_this.updateAdminDetails.bind(_this)} />}
                />

              <Route
                    path="/admin_ui"
                    render={(props) => <Admin {...props}
                                                          base_url={_this.state.base_url}
                                                          renderInThousands = {_this.renderInThousands.bind(_this)}
                                                          portal_base_url={_this.state.portal_base_url}
                                                          loginStatus= {this.state.loginStatus}
                                                          admin_details = {_this.state.admin_details}
                                                          updateAdminDetails={_this.updateAdminDetails.bind(_this)}/>}
                />

              <Route  path="/staff"
                      render={(props) => <StaffLogin {...props}
                                                                base_url={_this.state.base_url}
                                                                portal_base_url={_this.state.portal_base_url}
                                                                loginStatus= {this.state.loginStatus}
                                                                updateStaffDetails={_this.updateStaffDetails.bind(_this)} />}
              />

              <Route
                    path="/staff_ui"
                    render={(props) => <Staff {...props}
                                                          base_url={_this.state.base_url}
                                                          renderInThousands = {_this.renderInThousands.bind(_this)}
                                                          portal_base_url={_this.state.portal_base_url}
                                                          loginStatus= {this.state.loginStatus}
                                                          staff_details = {_this.state.staff_details}
                                                          updateStaffDetails={_this.updateStaffDetails.bind(_this)}/>}
              />

              <Route
                    path="/privacy_policy"
                    render={(props) => <PrivacyPolicy/>}
              />
          </Switch>
      </BrowserRouter>

    );

  }
}



ReactDOM.render(
<Approot/>,
document.getElementById('root')
);
